const firstLetterCapital = str => str.toLowerCase().replace(/_/g," ").replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });

const formatCellString = string => {
    if(!!string && string !== 'N/A'){
        return firstLetterCapital(string.toLocaleLowerCase());
    }
    return 'N/A';
};

export default { formatCellString };